<script setup>
import { readHistory } from '~/utils/localStorage'

const route = useRoute()

// skip checkURL at top
const areaName = 'japan'

// seo info
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : [{ text: '服装予報' }]

useCustomMetaPoint({ pointName: '', path: route.path, wntouch: true, type: 'top' })
useCustomJsonldPoint({ breadCrumbList })

// save and read history
let showHistory = []
if (import.meta.client) {
  showHistory = readHistory()
}

// get and prop data
const { data: mapData } = await useFetch('/api/clothes/map', { query: { area: areaName } })
const mapList = mapData.value?.mapList || []
const mapTitle = mapData.value?.mapTitle || ''
const pickupList = mapData.value?.pickupList || []
</script>

<template>
  <div>
    <NuxtLayout
      :bread-crumb-list="breadCrumbList"
      ads-key="area"
      name="common"
    >
      <ClothesMap
        :map-area="areaName"
        :map-list="mapList"
        :map-title="mapTitle"
        :type="'top'"
      />
      <ClothesGps />
      <!-- ads-atf のみ、Layout 内部にあるので、個別に記載。(他の広告は layout/common.vue に記載) -->
      <div
        id="2.5web_clothes_atf"
        class="ads-atf"
      />
      <ClothesTable
        :pickup-list="pickupList"
        :pickup-title="'各地の服装予報'"
      />
      <ClothesLegend />
      <ClothesSearch />
      <ClothesHistory :history-data="showHistory" />
    </NuxtLayout>
  </div>
</template>

<style scoped>
  .ads-atf {
    min-height: 50px;
    margin: 0px auto 10px;
    text-align: center;
    position: relative;
  }
</style>
